import { FC, useEffect } from 'react';
import { Swiper } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
import { MainSlide } from './slides/1-main';
import { ExploreSlide } from './slides/2-explore';
import { InteractSlide } from './slides/3-interact';
import { TipsSlide } from './slides/4-tips';
import { LemoSlide } from './slides/5-lemo';
import { Background } from './components/background';
import { NextPageTip } from './components/next-slide-tip';
import { Header } from './header';

import './style.scss';

export const MainV2: FC = () => {
  // polyfill dw/dh
  useEffect(() => {
    if (!CSS.supports('height', '1dvh')) {
      const $swiper = document.querySelector('main.v2') as HTMLDivElement;

      const observer = new ResizeObserver(() => {
        const width = window.innerWidth;
        const height = window.innerHeight;

        $swiper.style.setProperty('--dw', `${width / 100}px`);
        $swiper.style.setProperty('--dh', `${height / 100}px`);
      });
      observer.observe(document.body);

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return (
    <main className="v2">
      <Header />

      <Swiper
        className="homepage-swiper"
        direction="vertical"
        mousewheel={{ thresholdDelta: 20, thresholdTime: 500 }}
        modules={[Mousewheel]}
      >
        <Background />
        <NextPageTip />

        <MainSlide />
        <ExploreSlide />
        <InteractSlide />
        <TipsSlide />
        <LemoSlide />
      </Swiper>
    </main>
  );
};
